import * as React from 'react';

const StopwatchChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 7.1V6h2V4H9v2h2v1.1c-3.1.5-5.5 3.2-5.5 6.4 0 3.6 2.9 6.5 6.5 6.5s6.5-2.9 6.5-6.5c0-3.2-2.4-5.9-5.5-6.4zm2 8.2h-3.7V9.8H13v4.1h2v1.4z"
        />
    </svg>
);

StopwatchChunkySvg.displayName = 'StopwatchChunkySvg';
export default StopwatchChunkySvg;
